/* eslint-disable */
import React from 'react'
import { Input as AntdInput, Form } from 'antd'
import Label from 'components/Form/Label'
import styled from 'styled-components'

const { Item } = Form

const StyledItem = styled(Item)`
  > div {
    width: 100%;
    text-align: left;
  }
  border-radius: 10px;
  margin-bottom: 0px !important;
`
const AntdInputStyle = styled(AntdInput)`
  placeholder-shown {
    background: #fafafb !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #010e30;
  }
  height: ${props => (props.height ? props.height : '48px')};
  border-radius: 10px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
    border-radius: 10px;
    border: 1px solid #d6dbf7;
  }
  :hover {
    border-color: #d6dbf7;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #d6dbf7 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
    border-right-width: 0px !important;
  }
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #010e30;
`
const Input = ({
  label,
  type,
  name,
  rules,
  onChange,
  placeholder,
  required,
  disabled,
  width = '100%',
  height,
  marginRight,
  labelStyle,
  defaultValue,
  optional,
  noStyle = undefined,
  ...rest
}) => {
  return (
    <StyledItem
      style={{
        width: width,
        marginRight: marginRight,
      }}
      rules={rules}
      noStyle={noStyle}
      name={name}
      colon={false}
      required={false}
      label={
        label && (
            <Label required={required} labelStyle={labelStyle}>
              {label} <span>{optional}</span>
            </Label>
        )
      }
    >
      <AntdInputStyle
        {...rest}
        defaultValue={defaultValue}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        height={height}
      />
    </StyledItem>
  )
}
export default Input
